import { Button } from "@cmp-src/primitives/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "@cmp-src/primitives/tooltip";
import { LightningBoltIcon } from "@heroicons/react/outline";
import type { MouseEventHandler } from "react";

export interface QuickReserveButtonProps {
  /** Books the resource for the default time range. */
  onClick: MouseEventHandler<HTMLButtonElement>;
  /** Shows a spinner and disables the button while the reservation is being created. */
  isLoading?: boolean;
  disabled?: boolean;
  /**
   * Tooltip text: say which time range will be booked.
   * @default "Quick reserve at 8am - 5PM"
   */
  tooltipLabel?: string;
  /**
   * Accessible name of the icon-only button.
   * @default "Quick reserve"
   */
  ariaLabel?: string;
  className?: string;
}

/**
 * One-click booking of a resource for a default time range, with a tooltip that says which one.
 * Used in the map's resource details next to the full "Reserve" flow.
 */

export const QuickReserveButton = ({
  onClick,
  isLoading,
  disabled,
  tooltipLabel = "Quick reserve at 8am - 5PM",
  ariaLabel = "Quick reserve",
  className
}: QuickReserveButtonProps) => {
  return (
    <Tooltip delayDuration={100}>
      <TooltipTrigger asChild>
        <Button
          variant="outline"
          size="icon"
          aria-label={ariaLabel}
          isLoading={isLoading}
          disabled={disabled}
          onClick={onClick}
          className={className}
        >
          <LightningBoltIcon className="h-4 w-4" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        <p className="text-xs">{tooltipLabel}</p>
      </TooltipContent>
    </Tooltip>
  );
};
